var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 19.8001L24 24.0001L4 12.0001C6.78 10.4801 4.42 11.7801 12 7.62012L31 19.8001Z",
    fill: "#A87E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 16.2002L31 19.8002L12 7.62016L18.28 4.16016L37 16.2002Z",
    fill: "#F6CCAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 12C39.78 14.54 49.31 8.79 37 16.2L18.25 4.2L24 1L44 12Z",
    fill: "#A87E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0001 19.7998L26.0001 22.7998L13.7001 15.4198C13.1244 15.0744 12.65 14.5833 12.3245 13.9961C11.9991 13.4089 11.8342 12.7463 11.8463 12.0751C11.8585 11.4039 12.0473 10.7477 12.3938 10.1727C12.7404 9.5977 13.2323 9.12417 13.8201 8.7998L31.0001 19.7998Z",
    fill: "#BE927C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9999 16.2001L30.9999 19.8001L13.8199 8.8001C19.3499 5.8001 14.8199 8.2101 20.0999 5.3501L36.9999 16.2001Z",
    fill: "#FFDEC7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44 12.0001L37 16.2001L20.1 5.3501L26 2.1001C44.7 12.3801 41.62 10.6801 44 12.0001Z",
    fill: "#BE927C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44 12V35L24 47V24L44 12Z",
    fill: "#A87E6B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44 12V33L32.06 40.17C31.453 40.5347 30.76 40.7317 30.0519 40.7409C29.3438 40.7501 28.646 40.5711 28.0297 40.2223C27.4134 39.8735 26.9008 39.3673 26.5442 38.7555C26.1876 38.1437 25.9998 37.4482 26 36.74V22.8L44 12Z",
    fill: "#BE927C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37 16.2002V23.0002L31 26.0002V19.8002L37 16.2002Z",
    fill: "#F6CCAF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37 16.2002V22.0002L35.65 22.6702C35.1605 22.9159 34.6163 23.0322 34.0692 23.0082C33.522 22.9842 32.9901 22.8206 32.524 22.5329C32.058 22.2453 31.6733 21.8431 31.4065 21.3648C31.1398 20.8865 30.9998 20.3479 31 19.8002L37 16.2002Z",
    fill: "#FFDEC7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33V39.2L31 42.8V37L37 33Z",
    fill: "#F6CCAF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31 37.3301V42.8001L30 43.4001V38.0001L31 37.3301Z",
    fill: "#A87E6B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33V37.2L34.26 38.84C33.9339 39.0366 33.5615 39.143 33.1808 39.1485C32.8001 39.1539 32.4248 39.0582 32.0932 38.871C31.7616 38.6839 31.4857 38.4121 31.2936 38.0833C31.1016 37.7546 31.0002 37.3807 31 37L37 33Z",
    fill: "#FFDEC7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24V47L4 35V12L24 24Z",
    fill: "#A07765"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14 30V36L20 40V34L14 30Z",
    fill: "#C6C3D8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.82 8.7998C13.5548 8.94424 13.3094 9.12239 13.09 9.3298C14 9.9398 11.37 8.1998 30 20.3998V25.9998L31 25.4998V19.7998L13.82 8.7998Z",
    fill: "#A87E6B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/Pickup.4c17dc370fb3ca33e2f0a113b6669389.svg";
export { ForwardRef as ReactComponent };